export default "__VITE_ASSET__Bw9$_iLP__"